import React, {useState} from 'react';
import {Modal, ScrollView, Text, TouchableOpacity, View, Alert} from 'react-native';
import Feather from 'react-native-vector-icons/Feather';
import RNHTMLtoPDF from 'react-native-html-to-pdf';
import FileViewer from 'react-native-file-viewer';
import {Colors} from '../../../../../../constants/Colors';
import SortModal from '../../../../../Home/components/SortModal/SortModal';
import ProductModalList from '../ProductsModalList/ProductsModalList';
import {styles} from './styles';
import { useNavigation } from '@react-navigation/native';
import { AppRoutes } from '../../../../../../navigation/Routes.types';
import ButtonComponent from '../../../../../../components/ButtonComponent/ButtonComponent';
import { getAnalytics } from '@react-native-firebase/analytics';

interface IModalFilter {
  visible: boolean;
  onRequestClose: () => void;
  item: IStatusPedido;
  returnSort: (val: string) => void;
}

const OrdersModal = ({
  visible,
  onRequestClose,
  item,
  returnSort,
}: IModalFilter) => {
  const verifyOrderType = {
    ZS03: 'Bonificação',
    ZS11: 'Troca',
    ZS43: 'Compra',
  };

  const [sort, setSort] = useState<boolean>(false);
  const analyticsInstance = getAnalytics();
  const generateAndOpenPDF = async () => {
    try {
      const htmlContent = `
        <html>
          <head>
            <title>Detalhes do Pedido</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 20px;
              }
              h1 {
                color: #333;
              }
              p {
                font-size: 14px;
                color: #555;
              }
              .product-card {
                border-bottom: 1px solid #ddd;
                padding: 10px 0;
              }
              .product-title {
                font-size: 12px;
                color: #333;
              }
              .product-info {
                font-size: 12px;
                color: #555;
              }
            </style>
          </head>
          <body>
            <h1>Detalhes do Pedido</h1>
            <p><strong>Pedido:</strong> ${item?.['@attributes']?.ORDEM}</p>
            <p><strong>Tipo de Pedido:</strong> ${
              verifyOrderType[item?.Status?.AUART]
            }</p>
            <h2>Produtos</h2>
            <div>
              ${!!item?.Itens?.Item &&
                Array.isArray(item.Itens?.Item)
                  ? item.Itens?.Item.map(
                      (product) => `
                        <div class="product-card">
                          <p class="product-title">${product?.ARKTX}</p>
                          <p class="product-info">Quantidade: ${parseInt(product?.KWMENG, 10)}</p>
                          <p class="product-info">Situação: ${
                            product?.BEZEI && !Array.isArray(product.BEZEI) && product.BEZEI.trim() !== '' ? product.BEZEI : 'Confirmado'
                          }</p>
                          <p class="product-info">Preço: R$ ${product?.CMPRE}</p>
                        </div>
                      `
                    ).join('')
                  : `
                    <div class="product-card">
                      <p class="product-title">${item?.Itens?.Item?.ARKTX}</p>
                      <p class="product-info">Quantidade: ${
                        parseInt(item?.Itens?.Item?.KWMENG, 10)
                      }</p>
                      <p class="product-info">Situação: ${
                        item?.Itens?.Item?.BEZEI && !Array.isArray(item?.Itens?.Item?.BEZEI) &&
                        item?.Itens?.Item?.BEZEI?.trim() !== ''
                          ? item?.Itens?.Item?.BEZEI
                          : 'Confirmado'
                      }</p>
                      <p class="product-info">Preço: R$ ${
                        item?.Itens?.Item?.CMPRE
                      }</p>
                    </div>
                  `
              }
            </div>
          </body>
        </html>
      `;
  
      const options = {
        html: htmlContent,
        fileName: `Pedido_${item?.['@attributes']?.ORDEM}`,
        directory: 'Documents',
      };
   logEvent(analyticsInstance, 'generate_order_pdf', {
          order_number: item?.['@attributes']?.ORDEM,
          client_code: item?.['@attributes']?.CLIENTE,
        });
      const file = await RNHTMLtoPDF.convert(options);
  
      if (file.filePath) {
        await FileViewer.open(file.filePath);
      }
    } catch (error) {
      Alert.alert('Erro', 'Erro ao gerar ou abrir o PDF');
      console.error('Erro ao gerar ou abrir o PDF:', error);
    }
  };
  

  const navigation = useNavigation();

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
          </View>
          <ScrollView style={styles.containerDrop}>
            <Text style={styles.filterTitle}>
              Pedido: {item?.['@attributes']?.ORDEM}
            </Text>
            <Text style={styles.codeText}>
              Tipo de pedido: {verifyOrderType[item?.Status?.AUART]}
            </Text>
            <Text style={styles?.ProductsText}>Produtos</Text>
            {Array.isArray(item?.Itens?.Item) ? (
              item?.Itens?.Item?.map((item, index) => (
                <ProductModalList key={index} item={item} />
              ))
            ) : (
              <ProductModalList item={item?.Itens?.Item} />
            )}
          </ScrollView>
          {/* Centralize o botão aqui */}
          <View style={{alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
            <ButtonComponent title="Baixar Pedido" width="80%" onPress={generateAndOpenPDF} />
          </View>
          {item?.Itens?.Item && item?.Itens?.Item[0]?.BEZEI && !Array.isArray(item?.Itens?.Item[0]?.BEZEI) && item?.Itens?.Item[0]?.BEZEI.trim() !== '' && item?.Itens?.Item[0]?.BEZEI.trim() == 'Título em Atraso'  && (
          <View style={styles.containerButton}>
            <ButtonComponent
              title="Pagar Título"
              onPress={() => navigation.navigate(AppRoutes.DEBTS)}
              width='100%'
            />
          </View>
            )}
        </View>
      </View>
      <SortModal
        visible={sort}
        onRequestClose={() => setSort(false)}
        returnOrder={typeOrder => returnSort(typeOrder)}
      />
    </Modal>
  );
};

export default OrdersModal;
